import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { checkStoreState, setInitialStoreState } from '../../../../../common/utils';
import { ShipmentPlannerProfileItemBriefFacade } from './shipment-planner-profile-item-brief.facade';

@Injectable({
  providedIn: 'root',
})
export class ShipmentPlannerProfileItemBriefGuard {
  constructor(private shipmentPlannerProfileItemBriefFacade: ShipmentPlannerProfileItemBriefFacade) {}

  canActivate(route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Observable<boolean> {
    const {
      params: { shipmentPlannerProfileId },
    } = route;
    return checkStoreState(this.shipmentPlannerProfileItemBriefFacade, shipmentPlannerProfileId);
  }

  canDeactivate(): boolean {
    return setInitialStoreState(this.shipmentPlannerProfileItemBriefFacade);
  }
}
